if (window.addEventListener) {
	window.addEventListener("message", onMessage, false);
} else if (window.attachEvent) {
	window.attachEvent("onmessage", onMessage, false);
}

function onMessage(event) {
	var data = event.data;
	if (typeof(window[data.action]) == "function") {
		window[data.action].call(null, data.qty, data.handle);
	}
}

function addItemToCart(qty, handle) {
	
	// Retrieve product by handle
	jQuery.getJSON('/products/' + handle + '.js').done(function(product) {
		
		// Get vendor vendor_number
		jQuery("<div></div>").load("/products/" + product.handle + " #vendor_number", function(r, s, xhrObj) {
			var vendorNumber = jQuery(r).find("#vendor_number").val();
			
			// Add to cart
			jQuery.post('/cart/add.js', {
				quantity: qty,
				id: product.variants[0].id,
				properties: {'vendor_number': vendorNumber }
			}, function(lineItem){
				var $cartItem = jQuery(jQuery('[data-templates] [data-cartitem]').first().clone());
				$cartItem.find('.cart-item--image-wrapper a')
					.attr('href', lineItem.url)
					.html(lineItem.image != null ? 
						'<img src="' + lineItem.image + '">' 
						: 
						'<img src="https://cdn.shopify.com/s/files/1/0194/9335/5620/files/' + lineItem.vendor.toLowerCase() + '_placeholder.png?2870">');
				$cartItem.find('.cart-item--content-title a').text(lineItem.product_title + "\xD7" + lineItem.quantity);

				for(var i = 0; i < product.variants.length; i++) {
					if(product.variants[i].id == lineItem.variant_id) {
						if(product.variants[i].compare_at_price != null && product.variants[i].compare_at_price > 0){
							$cartItem.find('.cart-item--content-price .money.cart-item--sale-price').text(Shopify.formatMoney(product.variants[i].compare_at_price));
						}
						if(product.options[0].name !== 'Title' && product.variants[i].options[0] !== 'Default Title') {
							for(var j = 0; j < product.options.length; j++) {
								$cartItem.find('.cart-item--product-options').append('<span class="cart-item--option-name">' + product.options[j].name + '</span> ' + product.variants[i].options[j]);
							}
						}
					break;
				}
			}

			$cartItem.attr('data-cartitem-id', lineItem.id);
			$cartItem.attr('data-cartitem-price', lineItem.price);
			$cartItem.find('.cart-item--sku').html('<strong>SKU</strong> <span data-product-sku>' + lineItem.sku + '</span>');
			$cartItem.find('.cart-item--quantity select, .cart-item--quantity input').val(lineItem.quantity);
			$cartItem.find('.cart-item--total').html('<span class="money" data-cartitem-total="">' + Shopify.formatMoney(lineItem.line_price) + '</span>');
			$cartItem.find('.cart-item--notification').load("/products/" + lineItem.handle + " #product_inventory");

			if(jQuery('.cart-flyout--container .cartitems--container .cartitems').find('.cartitems-empty').length) {
				jQuery('.cart-flyout--container').find('.cart-title-right').html('<div class="cart-title-total--large"><div class="cart-title-total" data-cart-title-total="">Subtotal <span class="money" data-cart-total="">' + Shopify.formatMoney(lineItem.line_price) + '</span></div></div><button class="button-primary cart-title-button" name="checkout" type="submit" form="cart_flyout_form" aria-label="Checkout"><svg aria-hidden="true" focusable="false" role="presentation" width="28" height="26" viewBox="0 10 28 26" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" fill-rule="evenodd" d="M26.15 14.488L6.977 13.59l-.666-2.661C6.159 10.37 5.704 10 5.127 10H1.213C.547 10 0 10.558 0 11.238c0 .68.547 1.238 1.213 1.238h2.974l3.337 13.249-.82 3.465c-.092.371 0 .774.212 1.053.243.31.576.465.94.465H22.72c.667 0 1.214-.558 1.214-1.239 0-.68-.547-1.238-1.214-1.238H9.434l.333-1.423 12.135-.589c.455-.03.85-.31 1.032-.712l4.247-9.286c.181-.34.151-.774-.06-1.144-.212-.34-.577-.589-.97-.589zM22.297 36c-1.256 0-2.275-1.04-2.275-2.321 0-1.282 1.019-2.322 2.275-2.322s2.275 1.04 2.275 2.322c0 1.281-1.02 2.321-2.275 2.321zM10.92 33.679C10.92 34.96 9.9 36 8.646 36 7.39 36 6.37 34.96 6.37 33.679c0-1.282 1.019-2.322 2.275-2.322s2.275 1.04 2.275 2.322z"></path></svg>Checkout</button>');
				jQuery('.cart-flyout--container .cartitems--container .cartitems').html($cartItem);
				jQuery('.cart-flyout--container .cartitems--container .cartitems').append('<div class="cart-total"><div class="cart-checkout"></div></div>');
				var continueLink = jQuery('<a></a>').attr('href', 'javascript:void(0)').addClass('cart-continue').html('Continue shopping<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6"><g fill="currentColor" fill-rule="evenodd"><polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"></polygon><polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"></polygon></g></svg>')
					.click(function(){
						jQuery('.cart-flyout--container').removeClass('visible');
						jQuery('.cart-flyout--overlay').fadeOut(270);
					});
				jQuery('.cart-flyout--container .cartitems--container .cartitems').find('.cart-checkout').append(continueLink);
				$cartItem.find('[data-quantity-select]').change(function(e) {
					var $target = jQuery(event.currentTarget);
					var $item = $target.closest('[data-cartitem-id]');
					var quantity = parseInt($target.val(), 10);
					var quantity = Math.max(quantity, 0);
					var id = $item.data('cartitem-id');

					// If 10+ is selected toggle number input
					if(quantity == 10){
						$target.parent().parent('.form-field--qty-select').toggleClass('visible hidden').next('.form-field--qty-input').toggleClass('visible hidden');
					} else {
						// Update cart
						jQuery.post('/cart/change.js', {
							quantity: quantity,
							id: id
						}, function(cartObj){
							var filteredItems = cartObj.items.filter(function (item) {
							return item.id === id;
						});
						if (filteredItems[0].quantity !== quantity) {
							var $messageBanner = jQuery(jQuery('[data-templates] [data-message-banner]').first().clone());
							$messageBanner.find('[data-message-banner-content]').text('There are only ' + filteredItems[0].quantity + ' ' + filteredItems[0].title + ' currently available.', 'error');
							$messageBanner.addClass('message--error visible').css({"top":jQuery('.site-header-wrapper').first().height() + 'px'}).appendTo(jQuery('body'));

							$cartItem.find('[data-quantity-input]').val(filteredItems[0].quantity);
							$cartItem.find('[data-quantity-select]').val(filteredItems[0].quantity);
						}

						$target.parent().parent().parent('.cart-item--quantity').next('.cart-item--total').children('span').html(Shopify.formatMoney(filteredItems[0].final_line_price));
						jQuery('.cart-flyout--container .cart-title-total span').html(Shopify.formatMoney(cartObj.items_subtotal_price));
						// Update cart count
						jQuery('.cart-flyout--container').find('[data-header-cart-count]').attr('data-header-cart-count', cartObj.item_count).toggleClass('visible', cartObj.item_count > 0);
					}, 'json');
				}
			});
			$cartItem.find('.cart-item--remove a').click(function(){
				jQuery.post('/cart/change.js', {
					quantity: 0,
					id: lineItem.id
				}, function(cartObj){
					$cartItem.remove();

					if(cartObj.item_count == 0) {
						var aElem = jQuery('<a></a>').attr('href', 'javascript:void(0)').addClass('cart-continue').html('Continue shopping<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6"><g fill="currentColor" fill-rule="evenodd"><polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"></polygon><polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"></polygon></g></svg>')
							.click(function(){
								$('.cart-flyout--container').removeClass('visible');
								$('.cart-flyout--overlay').fadeOut(270);
							});
						jQuery('.cart-flyout--container').find('.cart-title-right').html(aElem);
						jQuery('.cart-flyout--container .cartitems--container .cartitems').html('<div class="cartitems-empty"><div class="cartitems-empty--inner"><p>Your cart is empty</p></div></div>');
					} else {
						jQuery('.cart-flyout--container').find('.cart-title-total span').html(Shopify.formatMoney(cartObj.items_subtotal_price));
					}

					// Update cart count
					$('.cart-flyout--container').find('[data-header-cart-count]').attr('data-header-cart-count', cartObj.item_count).toggleClass('visible', cartObj.item_count > 0);
				}, 'json');
			});
		} else {
			if(jQuery('.cart-flyout--container .cartitems--container .cartitems').find('[data-cartitem-id="' + lineItem.id + '"]').length){
				jQuery('.cart-flyout--container .cartitems--container .cartitems').find('[data-cartitem-id="' + lineItem.id + '"]').find('.cart-item--quantity select, .cart-item--quantity input').val(lineItem.quantity);
			} else {
				jQuery('.cart-flyout--container .cartitems--container .cartitems').prepend($cartItem);
				$cartItem.find('[data-quantity-select], [data-quantity-input]').change(function(e) {
					var $target = jQuery(event.currentTarget);
					var $item = $target.closest('[data-cartitem-id]');
					var quantity = parseInt($target.val(), 10);
					quantity = Math.max(quantity, 0);
					var id = $item.data('cartitem-id');

				// If 10+ is selected toggle number input
				if(quantity == 10){
					$target.parent().parent('.form-field--qty-select').toggleClass('visible hidden').next('.form-field--qty-input').toggleClass('visible hidden');
				} else {
					// Update cart
					jQuery.post('/cart/change.js', {
						quantity: quantity,
						id: id
					}, function(cartObj){
						var filteredItems = cartObj.items.filter(function (item) {
						return item.id === id;
					});

					if (filteredItems[0].quantity !== quantity) {
						var $messageBanner = jQuery(jQuery('[data-templates] [data-message-banner]').first().clone());
						$messageBanner.find('[data-message-banner-content]').text('There are only ' + filteredItems[0].quantity + ' ' + filteredItems[0].title + ' currently available.', 'error');
						$messageBanner.addClass('message--error visible').css({"top":jQuery('.site-header-wrapper').first().height() + 'px'}).appendTo(jQuery('body'));

						$cartItem.find('[data-quantity-input]').val(filteredItems[0].quantity);
						$cartItem.find('[data-quantity-select]').val(filteredItems[0].quantity);
					}

					$target.parent().parent().parent('.cart-item--quantity').next('.cart-item--total').children('span').html(Shopify.formatMoney(filteredItems[0].final_line_price));
					jQuery('.cart-flyout--container .cart-title-total span').html(Shopify.formatMoney(cartObj.items_subtotal_price));
					// Update cart count
					jQuery('.cart-flyout--container').find('[data-header-cart-count]').attr('data-header-cart-count', cartObj.item_count).toggleClass('visible', cartObj.item_count > 0);
					}, 'json');
				}
			});
			$cartItem.find('.cart-item--remove a').click(function(){
				jQuery.post('/cart/change.js', {
					quantity: 0,
					id: lineItem.id
				}, function(cartObj){
					$cartItem.remove();

					if(cartObj.item_count == 0) {
						var aElem = jQuery('<a></a>').attr('href', 'javascript:void(0)').addClass('cart-continue').html('Continue shopping<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6"><g fill="currentColor" fill-rule="evenodd"><polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"></polygon><polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"></polygon></g></svg>').click(function(){
						jQuery('.cart-flyout--container').removeClass('visible');
						jQuery('.cart-flyout--overlay').fadeOut(270);
					});
					jQuery('.cart-flyout--container').find('.cart-title-right').html(aElem);
					jQuery('.cart-flyout--container .cartitems--container .cartitems').html('<div class="cartitems-empty"><div class="cartitems-empty--inner"><p>Your cart is empty</p></div></div>');
				} else {
					jQuery('.cart-flyout--container').find('.cart-title-total span').html(Shopify.formatMoney(cartObj.items_subtotal_price));
				}

				// Update cart count
				jQuery('.cart-flyout--container').find('[data-header-cart-count]').attr('data-header-cart-count', cartObj.item_count).toggleClass('visible', cartObj.item_count > 0);
			}, 'json');
		});
	}
}

			jQuery('.cart-flyout--container').addClass('visible');
			jQuery('.cart-flyout--overlay').fadeIn(270);

			// Update cart count
				jQuery.get('/cart.js', function(cartObj){
					jQuery('.cart-flyout--container').find('[data-header-cart-count]').attr('data-header-cart-count', cartObj.item_count).toggleClass('visible', cartObj.item_count > 0);
					jQuery('.cart-flyout--container').find('.cart-title-total span').html(Shopify.formatMoney(cartObj.items_subtotal_price));
				}, 'json');
			}, 'json').fail(function(xhrObj) {
				var response = JSON.parse(xhrObj.responseText);
				alert(response.message + "\n" + response.description + ' - Please complete our Parts Inquiry form or call 425-412-4006.');
			});
		});
	}).fail(function(xhrObj) {
		alert("This product is not currently available on our website. Please complete our Parts Inquiry form or call 425-412-4006.");
	});
}